import React, { useState } from 'react';
import { SwitchComponent } from './Index';
import { toast } from 'react-toastify';
import opsService from '../../services/ops/opsService';

export const BonTranport = ({ shippingId, status }) => {
    const [isAddBonTransport, setIsAddBonTransport] = useState(status);

    const handleToggleBonTransport = () => {
        try {
            const toastId = toast.loading("Mise à jour...");
            opsService.toggleBonTransport({
                id: shippingId
            }).then((data) => {

                toast.update(toastId, {
                    render: "Bon de transport activé",
                    type: "success",
                    isLoading: false,
                    autoClose: 2000,
                });
                setIsAddBonTransport(!isAddBonTransport);

            },
                (error) => {
                    toast.update(toastId, {
                        render: "Une erreur est survenue",
                        type: "error",
                        isLoading: false,
                        autoClose: 2000,
                    });
                })

        } catch (error) {

        }
    }
    return (
        <div className=" w-fit">
            <SwitchComponent
                label={"Bon de transport"}
                checked={isAddBonTransport}
                onChange={handleToggleBonTransport}
            />
        </div>
    );
}

